// These types/enums are also defined in the cbo-nest-library. They should be kept in sync
// TODO: Remove these types from the nest-library

export enum Origin {
  ADMIN = 'admin',
  INVENTORY = 'inventory',
  LABOR = 'labor',
  SALES = 'sales',
}

export type TAuditEventType = UserEvent | DbEvent | OrchestratorEvent | OnboardingEvent | TagEvent;

export enum UserEvent {
  LOGIN = 'login',
  LOGOUT = 'logout',
}

export enum DbEvent {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum OrchestratorEvent {
  RUN_JOB = 'runJob',
  RUN_ALL_JOBS = 'runAllJobs',
  ROLLBACK_JOB = 'rollbackJob',
  ROLLBACK_ALL_JOBS = 'rollbackAllJobs',
}

export enum OnboardingEvent {
  INITIATED = 'initiated',
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum TagEvent {
  ADD = 'add',
  REMOVE = 'remove',
}

export enum Priority {
  // 2-digit prefix for sorting
  // Allows for other priorities to be inserted (ex: MEDIUM_HIGH: '15-medium-high')
  HIGH = '10-high',
  MEDIUM = '20-medium',
  LOW = '30-low',
}

/**
 * Audit entities
 * - Enums of tables in each service
 */
export type TEntity =
  | EmployeeConfigurationEntity
  | EmployeeInformationEntity
  | LaborEntity
  | HouseAccountsEntity
  | NotificationEntity
  | RecipeEntity
  | SchedulingEntity
  | UnitOfMeasureEntity
  | VendorEntity
  | GLAccountEntity
  | SalesEntity;

export enum EmployeeConfigurationEntity {
  EMPLOYEE_CONFIGURATION = 'employee_configuration',
  LABOR_CONFIGS_BY_SITE = 'labor_configs_by_site',
  JOB_CODE_DEFINITION = 'job_code_definition',
  PAY_RATE = 'pay_rate',
  LABOR_REPORT_GROUP = 'labor_group',
  TIP_SHARE_GROUP = 'tip_share_group',
  EMPLOYEE_JOB_CODE_ASSIGNMENT = 'employee_job_code_assignment',
}

export enum EmployeeInformationEntity {
  EMERGENCY_CONTACT = 'emergency_contact',
  PERSONAL_INFORMATION = 'personal_information',
  CONTACT_INFORMATION = 'contact_information',
  CERTIFICATIONS = 'certifications',
  EMPLOYEE = 'employee',
}

export enum LaborEntity {
  EMPLOYEE = 'employee',
  JOB = 'job',
  JOB_PROFILE = 'job_profile',
  JOB_PROFILE_HISTORY = 'job_profile_history',
  LABOR_GROUP = 'labor_group',
  CONTACT = 'contact',
  CERTIFICATION = 'certification',
  EMPLOYMENT_HISTORY = 'employment_history',
  POS_MAPPING = 'pos_mapping',
}

export enum HouseAccountsEntity {
  HOUSE_ACCOUNT = 'house_account',
  SUMMARY_VIEW = 'house_account_summary_view',
  ACTIVITY_VIEW = 'house_account_activity_view',
  STATEMENT = 'house_account_statement',
  TRANSACTION = 'house_account_transaction',
  CONSUMER = 'consumer',
}

export enum NotificationEntity {
  NOTIFICATION = 'notification',
  NOTIFICATION_SETTINGS = 'notification_settings',
  EVENT_TYPE = 'event_type',
  EVENT_TYPE_ROLE = 'event_type_role',
}

export enum RecipeEntity {
  RAW_ITEM = 'raw_item',
}

export enum SchedulingEntity {
  SHIFT = 'shift',
  BREAK = 'break',
  SCHEDULE = 'schedule',
  SCHEDULE_CHANGE = 'schedule_change',
  DECLARED_TIP = 'declared_tip',
  WORK_WEEK_CONFIG = 'work_week_config',
}

export enum UnitOfMeasureEntity {
  INDUSTRY_UNIT = 'industry_unit',
  CONTAINER_UNIT = 'container_unit',
  RECEIVING_UNIT = 'receiving_unit',
}

export enum VendorEntity {
  VENDOR = 'vendor',
  VENDOR_ITEM = 'vendor_item',
  INVOICE = 'invoice',
  INVOICE_ITEM = 'invoice_item',
  VENDOR_SERVICE_ITEM = 'vendor_service_item',
}

export enum GLAccountEntity {
  GL_ACCOUNT = 'gl_account',
  GL_ACCOUNT_TYPE = 'gl_account_type',
  JOB_CODE_DEFINITION_MAPPING = 'job_code_definition_mapping',
  SALE_ENTITY_MAPPING = 'sales_entity_mapping',
}

export enum SalesEntity {
  SALES_REPORT_CONFIG = 'sales_report_config',
  DEFAULT_SALES_REPORT_CONFIG = 'default_sales_report_config',
}

export const AllEntities: string[] = ([] as string[]).concat(
  Object.values(EmployeeConfigurationEntity).map((value: string) => value),
  Object.values(EmployeeInformationEntity).map((value: string) => value),
  Object.values(LaborEntity).map((value: string) => value),
  Object.values(HouseAccountsEntity).map((value: string) => value),
  Object.values(NotificationEntity).map((value: string) => value),
  Object.values(RecipeEntity).map((value: string) => value),
  Object.values(SchedulingEntity).map((value: string) => value),
  Object.values(UnitOfMeasureEntity).map((value: string) => value),
  Object.values(VendorEntity).map((value: string) => value),
  Object.values(GLAccountEntity).map((value: string) => value),
  Object.values(SalesEntity).map((value: string) => value)
);
